// 261010 Epic 2 / P3e — Pass Diễn xuất (Acting) riêng chạy trước Đạo diễn. Mirror BE `domains/filmActingDomain.ts` + `_p3e/dev-be-1.md` §8 và "Lượt 2" (nguồn sự thật).
// Mọi khoá mới trong payload plan là TUỲ CHỌN để BE cũ (không có khoá) vẫn chạy như trước.

/** Bốn cột diễn xuất của shot mà BE dựng từ cue; sửa tay một trong bốn ⇒ BE thêm vào `manualFields` (thứ tự cố định này). */
export type ActingManualField = 'performance' | 'motion' | 'propChange' | 'beatKind';
export const ACTING_MANUAL_FIELD_ORDER: readonly ActingManualField[] = ['performance', 'motion', 'propChange', 'beatKind'];

/** Nhân-quả vật lý nhìn thấy được, CHỈ có ở nhịp hành động / phép: nguồn → đường → tiếp xúc → phản ứng → dư âm. KHÔNG phải `FilmShot.effect`. */
export interface EffectMechanism { source: string; path: string; contact: string; reaction: string; aftermath: string }

/** Một cue diễn xuất của event (kích thích → phản ứng cơ thể → trạng thái sau). `id` dạng `C1`, `C2`… */
export interface ActingCue {
  id: string;
  beatOrders: number[];
  stimulus: string;
  physicalResponse: string;
  stateShift: string;
  performance: string;
  motion: string | null;
  propChange: string | null;
  beatKind: 'STIMULUS' | 'REACTION' | 'DECISION' | null;
  dialogueDelivery?: string | null;
  effectMechanism?: EffectMechanism | null;
  ruleIds: string[];
}

/** 261030 — dấu «AI bị chặn nội dung ở mọi đường ⇒ máy dựng cue chỉ từ câu nguồn» (BE `plan.blocked`, `getState.blocked`). Vắng / null = diễn xuất do AI viết bình thường. */
export interface ActingBlocked { code: string; reason?: string; fallbackTried?: boolean; at?: string }

/** `film_events.acting_plan` — artifact cấp event (raw trong payload `getEventPlan`, đi theo `...event`). */
export interface ActingPlan {
  version: number;
  inputHash: string;
  profileVersion: number | null;
  exceptionHash: string | null;
  status: 'AI' | 'EDITED';
  cues: ActingCue[];
  warnings?: string[];
  meta?: { model: string | null; costUsd: number | null; costSource: string | null } | null;
  /** 261030 — có ⇒ cue lấy nguyên từ truyện (`meta.model = 'source-only'`), AI không viết được. */
  blocked?: ActingBlocked | null;
}

/** `film_shots.acting_cue_refs`. `manualFields` khác rỗng ⇒ event được bảo vệ (AI không ghi đè). */
export interface ActingCueRefs {
  cueIds: string[];
  actingInputHash: string | null;
  mappedAt: string | null;
  manualFields: ActingManualField[];
}

/** Cờ lỗi mềm của chặng 2 theo event. `code` đã bỏ tiền tố `WORKFLOW_RUN_FLAG:` của alert. */
export type ActingFlagCode = 'ACTING_FAILED' | 'ACTING_MANUAL_EDIT_EXISTS' | 'LEGACY_SHOTS_KEPT';
export interface ActingFlag { code: string; eventId?: string | null }

/** `workflow-status.workflowRuns.stage2.actingOutcomes[]`. */
export interface ActingOutcome { eventId: string; status: 'DONE' | 'REUSED' | 'FAILED' | 'MANUAL' | 'LEGACY'; code?: string; reason?: string }

/** `GET /plans/:planId/events/:eventId/acting` — chỉ đọc, 0 AI. */
export interface ActingState {
  eventId: string;
  status: 'NONE' | 'AI' | 'EDITED';
  inputHash: string | null;
  currentHash: string | null;
  stale: boolean;
  templateVersion: string | null;
  profileVersion: number | null;
  exceptionHash: string | null;
  cues: ActingCue[];
  warnings: string[];
  updatedAt: string | null;
  protected: boolean;
  planEdited: boolean;
  manualShots: Array<{ shotId: string; fields: ActingManualField[] }>;
  /** 261010 UI2 (L6c) — mã đối chiếu để gỡ dấu sửa tay (`POST …/acting/clear-manual`.baseHash). BE cũ không có ⇒ tuỳ chọn. */
  manualHash?: string;
  /** 261030 — có ⇒ cue của video này lấy từ nguồn vì AI bị chặn nội dung (BE cũ không có ⇒ tuỳ chọn). */
  blocked?: ActingBlocked | null;
  shots: Array<{ shotId: string; cueIds: string[]; matches: boolean; manualFields: ActingManualField[] }>;
}

/** 202 của `POST …/acting` và `POST …/direct-acting` (job nền khoá `FILM_DIRECT` của plan). */
export interface ActingRunAccepted { started: boolean; jobId?: string; message?: string }
